/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import { KeyLookup, TableColumnDef, TABLE_KEY_ACTION } from "./table";
export const LOGONID = "logonId";
export const FIRSTNAME = "address.firstName";
export const LASTNAME = "address.lastName";
export const ADDRESS = "address.address1";
export const STATUS = "status";

export const LOGONID_V2 = "customerDetails.logonId";
export const FIRSTNAME_V2 = "firstName";
export const LASTNAME_V2 = "lastName";
export const ADDRESS_V2 = "customerDetails.userInformation.address1";
export const STATUS_V2 = "userRegistry.status";

export const TABLE_COLUMNS: TableColumnDef[] = [
  {
    title: "Customer.LogonID",
    idProp: "id",
    keyLookup: {
      key: LOGONID,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.FirstName",
    idProp: "id",
    keyLookup: {
      key: FIRSTNAME,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.LastName",
    idProp: "id",
    keyLookup: {
      key: LASTNAME,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.Address",
    idProp: "id",
    keyLookup: {
      key: ADDRESS,
    } as KeyLookup,
    sortable: false,
  },
  {
    title: "Customer.Status",
    idProp: "id",
    keyLookup: {
      key: STATUS,
      translateKeyPrefix: "Customer.Status",
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "",
    idProp: "id",
    keyLookup: {
      key: TABLE_KEY_ACTION,
      translateKeyPrefix: "Table.Actions.",
    } as KeyLookup,
    sortable: false,
  },
];

export const TABLE_COLUMNS_V2: TableColumnDef[] = [
  {
    title: "Customer.LogonID",
    idProp: "id",
    keyLookup: {
      key: LOGONID_V2,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.FirstName",
    idProp: "id",
    keyLookup: {
      key: FIRSTNAME_V2,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.LastName",
    idProp: "id",
    keyLookup: {
      key: LASTNAME_V2,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "Customer.Address",
    idProp: "id",
    keyLookup: {
      key: ADDRESS_V2,
    } as KeyLookup,
    sortable: false,
  },
  {
    title: "Customer.Status",
    idProp: "id",
    keyLookup: {
      key: STATUS_V2,
      translateKeyPrefix: "Customer.Status",
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "",
    idProp: "id",
    keyLookup: {
      key: TABLE_KEY_ACTION,
      translateKeyPrefix: "Table.Actions.",
    } as KeyLookup,
    sortable: false,
  },
];

export const TABLE_ACTION = {
  ACCESS_ACCOUNT: "accessAcount",
  ENABLE_DISABLE_ACCOUNT: "enableDisableAccount",
  REST_PASSWORD: "resetPassword",
  VIEW_DETAIL: "viewDetail",
};

export const TABLE_ACTIONS: string[] = [
  TABLE_ACTION.ACCESS_ACCOUNT,
  TABLE_ACTION.ENABLE_DISABLE_ACCOUNT,
  TABLE_ACTION.REST_PASSWORD,
  TABLE_ACTION.VIEW_DETAIL,
];

export const SORT_LOGINID_ASC = "logonId";
export const SORT_LOGINID_DESC = "-logonId";
export const SORT_FIRSTNAME_ASC = "firstName";
export const SORT_FIRSTNAME_DESC = "-firstName";
export const SORT_LASTNAME_ASC = "lastName";
export const SORT_LASTNAME_DESC = "-lastName";
export const SORT_STATUS_ASC = {
  orderByTableName: "USERREG",
  orderByFieldName: "status",
};
export const SORT_STATUS_DESC = {
  orderByTableName: "USERREG",
  orderByFieldName: "status DESC",
};
export const SORT_ADDRESS_ASC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "address1",
};
export const SORT_ADDRESS_DESC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "address1 DESC",
};

export const TOP_CLIENTS_SEARCH_BY_OPTIONS = [
  {
    value: "NumberOfTransactions",
  },
  {
    value: "TotalPurchasesAmount",
  },
];
